module.exports = __webpack_public_path__ + "0af5d249/img/chevron-down-icon.5542f65c.svg";